import { selector } from "recoil";
import {
  checkinDetailState,
  surveyResponseState,
  surveySummaryState,
  learningResponseModalState,
  learningResponseState
} from "./atom";

export const checkinDetailSelector = selector({
  key: "checkinDetailSelector",
  get: ({ get }) => {
    return get(checkinDetailState);
  },
  set: ({ set }, newOptions) => {
    set(checkinDetailState, newOptions);
  }
});

export const surveyResponseSelector = selector({
  key: "surveyResponseSelector",
  get: ({ get }) => {
    return get(surveyResponseState);
  },
  set: ({ set }, newOptions) => {
    set(surveyResponseState, newOptions);
  }
});

export const surveySummarySelector = selector({
  key: "surveySummarySelector",
  get: ({ get }) => {
    return get(surveySummaryState);
  },
  set: ({ set }, newOptions) => {
    set(surveySummaryState, newOptions);
  }
});

export const learningResponseModalSelector = selector({
  key: "learningResponseModalSelector",
  get: ({ get }) => {
    return get(learningResponseModalState);
  },
  set: ({ set }, newOptions) => {
    set(learningResponseModalState, newOptions);
  }
});

export const learningResponseSelector = selector({
  key: "learningResponseSelector",
  get: ({ get }) => {
    return get(learningResponseState);
  },
  set: ({ set }, newOptions) => {
    set(learningResponseState, newOptions);
  }
});